var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEllipseIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 52,
  height: 52,
  fill: "none",
  viewBox: "0 0 52 52"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 26,
  r: 23.451,
  stroke: "#00A32E",
  strokeDasharray: "1.02 1.02",
  strokeWidth: 5.098
})));
export { SvgEllipseIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTIiIGhlaWdodD0iNTIiIHZpZXdCb3g9IjAgMCA1MiA1MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjYiIGN5PSIyNiIgcj0iMjMuNDUxIiBzdHJva2U9IiMwMEEzMkUiIHN0cm9rZS13aWR0aD0iNS4wOTgwNCIgc3Ryb2tlLWRhc2hhcnJheT0iMS4wMiAxLjAyIi8+Cjwvc3ZnPgo=";